import { api } from "./api";

const TOKEN_KEY = "avantech_admin_token";
const USER_KEY = "avantech_admin_user";

export function getToken() {
  return typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
}

export function getUser() {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export async function login(email, password) {
  const res = await api.post("/auth/login", { email, password });
  setSession(res.data.token, res.data.user);
  return res.data;
}

export async function me() {
  const token = getToken();
  if (!token) throw new Error("not_authenticated");
  const res = await api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
}

export function authHeaders() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
